import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import ListView from 'components/ListView';
import styles from './index.module.scss';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import { followupEventActions } from 'containers/Pages/Events';
import arePropsEqual from 'fast-deep-equal';
import { isEmpty, uniqueId } from 'lodash';
import { t } from 'i18next';
import { validate } from 'uuid';

const ListData = ({ data, col, className, showPaginate }) => {
  const bootstrapId = data => {
    return data.map(m => {
      if (!m.id) {
        // if there is no id, then bootstrap
        return {
          ...m,
          id: uniqueId('listData'),
          action: t(m.action),
          role: { data: [m.role?.data?.map(roleData => t(roleData))] },
        };
      } else
        return {
          ...m,
          action: t(m.action),
          role: { data: [m.role?.data?.map(roleData => t(roleData))] },
          ...(m.id && !validate(m.id) && { id: t(m.id) }),
        };
    });
  };
  const [agGridApi, setApi] = useState([]);

  const dispatch = useDispatch();

  const setPicked = useCallback(
    id => {
      dispatch(
        followupEventActions.setFollowupEventID({ followupEventID: id }),
      );
    },
    [dispatch],
  );

  const onSelect = () => {
    if (isEmpty(agGridApi)) return;
    const selectedData = agGridApi?.getSelectedRows();
    if (
      selectedData &&
      selectedData[0]?.id &&
      !selectedData[0]?.id.includes('listData')
    ) {
      setPicked(selectedData[0]?.id);
    }
    agGridApi.deselectAll();
  };

  return (
    <div className={cn(styles.listPanelHeader, className)}>
      <ListView
        agGridApi={agGridApi}
        rowData={bootstrapId(data)}
        columns={col}
        setApi={setApi}
        onSelect={onSelect}
        totalEntries={data?.length}
        showPaginate={showPaginate}
      />
    </div>
  );
};

ListData.propTypes = {
  data: PropTypes.array,
  col: PropTypes.array,
  className: PropTypes.string,
  showPaginate: PropTypes.bool,
};

export default React.memo(ListData, (prev, next) => {
  return arePropsEqual(prev, next);
});
